// extracted by mini-css-extract-plugin
export default {"dateText":"PointCard_dateText__lzNcW","micLocation":"PointCard_micLocation__8SnV5","pointInfoText":"PointCard_pointInfoText__vjxm9"};